module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"siteId":"188","matomoUrl":"https://stats.goeast.ch/","siteUrl":"https://www.pflegeheim-heiligkreuz.ch"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
